// extracted by mini-css-extract-plugin
export var readonly = "_im-1";
export var star = "_im-0";